import React from 'react'
import CnDownloads from './CnDownloads'

const CnDownloadsWithEnv: React.FC = () => (
  <CnDownloads mobileAppGaTrackingId={process.env.MOBILE_APP_GA_TRACKING_ID} />
)

export default CnDownloadsWithEnv
